module.exports = __webpack_public_path__ + "img/loginQuoteImage07.1c0f6d7f.webp";